<template>
  <div>
    <validated-form
      name="menuItemChild"
      @valid-submit="update"
    >
      <div class="section section--half-padding sticky-top">
        <div class="layout layout--horizontal">
          <button
            class="link link--has-title"
            type="button"
            tabindex="-1"
            @click="close"
          >
            <div class="layout layout--icon layout--icon-extra-spacing">
              <span class="icon icon--smedium far fa-arrow-left dark-gray" />

              <h2 class="title title--3 grow">
                {{ item.displayName }}
              </h2>
            </div>
          </button>

          <button
            v-if="allowDeselect && selectedModifiers"
            class="button button--danger button--icon button--small"
            type="button"
            title="Deselect"
            @click="deselect"
          >
            <span class="icon far fa-trash-alt" />
          </button>
        </div>
      </div>

      <div
        v-if="item.modifierGroups.length > 0"
        class="section section--half-padding"
      >
        <modifier-groups
          :groups="item.modifierGroups"
          :read-only="readOnly"
          :hide-prices="selectedLocation.features.HidePrices"
          :selected-modifiers="selectedModifiers"
          @selected="modifiersSelectedHandler"
        />
      </div>

      <div
        v-if="!readOnly"
        class="section section--half-padding section--alt-background section--shadow sticky-bottom"
      >
        <div class="center">
          <button
            class="button button--primary button--auto-width"
            type="submit"
          >
            Select
            <template v-if="priceWithModifiers > 0 && !selectedLocation.features.HidePrices">+{{ $dollars(priceWithModifiers) }}</template>
          </button>
        </div>
      </div>
    </validated-form>
  </div>
</template>

<script>
  import calculatePriceWithModifiers from '@/helpers/calculate-price-with-modifiers';
  import { mapGetters } from 'vuex';

  export default {
    name: 'MenuItemChild',

    props: {
      allowDeselect: {
        type: Boolean,
        default: false
      },
      item: {
        type: Object,
        required: true
      },
      readOnly: {
        type: Boolean,
        default: false
      },
      selectedQuantity: {
        type: Number,
        default: null
      },
      selectedModifiers: {
        type: Array,
        default: null
      }
    },

    data() {
      return {
        modifiers: [],
        quantity: 1
      };
    },

    computed: {
      ...mapGetters('locations', ['selectedLocation']),
      priceWithModifiers() {
        return calculatePriceWithModifiers(this.item, this.modifiers) * this.quantity;
      }
    },

    created() {
      this.createdHandler();
    },

    methods: {
      close() {
        this.$emit('close');
      },

      createdHandler() {
        this.quantity = this.selectedQuantity || 1;
      },

      deselect() {
        this.$emit('deselect', this.item.menuItemId);
      },

      modifiersSelectedHandler(modifiers) {
        this.modifiers = modifiers;
      },

      update() {
        this.$emit('update', {
          item: this.item,
          quantity: this.quantity,
          modifiers: this.modifiers
        });
      }
    }
  };
</script>
